/**
 * THE OFF-SWITCH FOR THIS SITE'S SEAT LIMIT, on the client side. Currently OFF — per-user
 * licensing has been deferred, and the feature is parked rather than removed.
 *
 * ⚠️ THIS IS THE LESSER HALF OF THE SWITCH. The authority is `SeatCapFeature.Enabled` in the
 * Function App (`src/CSM.Service/Licensing/SeatCapFeature.cs`), because that is what decides
 * whether a save is refused. All this flag does is stop the page ASKING — see
 * `getUserAccessCap` in `services/ApiService.ts`, which is the single place it is read.
 *
 * KEEP THE TWO IN STEP, AND UNDERSTAND WHAT HAPPENS IF THEY DRIFT — neither direction breaks
 * anything, which is why nothing will shout at you:
 *
 *  - **Client off, server on** — the server enforces the cap and refuses over-limit saves with
 *    a 409, but the manager sees no counter and no early warning. The refusal toast still
 *    explains itself, so this is untidy rather than broken.
 *  - **Client on, server off** — the page asks, the server answers `source: "disabled"`, and
 *    the page shows nothing. Identical to both being off, plus one wasted request.
 *
 * ⚠️ WHAT THIS DOES NOT TOUCH: the Analytics-only confinement in `utility/analyticsOnlyAccess.ts`
 * and `PrivateRoute`. A user with neither box ticked is still sent to `/Analytics`. That is a
 * view rule about screens that would be empty for them, and it was deliberately left live when
 * the seat cap was parked — the two shipped together but are independent decisions.
 *
 * TO SWITCH IT BACK ON: set this to `true`, set `SeatCapFeature.Enabled` to `true` in the
 * Function App, and do the per-environment setup in that repo's `Licensing/README.md`.
 *
 * ⚠️ ANNOTATED `: boolean`, NOT LEFT TO INFER `false`. Without the annotation TypeScript narrows
 * it to the literal type `false`, marks the guarded request in `getUserAccessCap` as dead code
 * and greys it out — and under `allowUnreachableCode: false` or `CI=true` that becomes a build
 * error for code we are deliberately keeping. Same reason the Function App's mirror of this is
 * a property rather than a `const`.
 */
export const SEAT_CAPS_ENABLED: boolean = false;
